"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePoller = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var focused_page_1 = require("../../misc/focused-page");
var usePoller = function (props) {
    var timer = React.useRef();
    var isPageNotFocused = (0, focused_page_1.useIsFocusedNotPage)();
    var isPageNotFocusedPrevious = React.useRef(isPageNotFocused);
    var _a = React.useState(false), forcePollingIndicator = _a[0], setForcePollingIndicator = _a[1];
    React.useEffect(function () {
        if (timer.current) {
            clearInterval(timer.current);
        }
        if (isPageNotFocused || props.isDisabled) {
            return;
        }
        timer.current = setInterval(function () {
            props.pollingFunction();
        }, props.interval);
        var currentTimer = timer.current;
        return function () {
            if (currentTimer) {
                clearInterval(currentTimer);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.pollingFunction, isPageNotFocused]);
    var forcePolling = function () {
        setForcePollingIndicator(!forcePollingIndicator);
    };
    React.useEffect(function () {
        if (isPageNotFocused === false && isPageNotFocused !== isPageNotFocusedPrevious.current) {
            forcePolling();
        }
        isPageNotFocusedPrevious.current = isPageNotFocused;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPageNotFocused]);
    return {
        forcePolling: forcePolling
    };
};
exports.usePoller = usePoller;
//# sourceMappingURL=index.js.map